import { ShieldCheck, EyeOff, Lock } from "lucide-react";

/**
 * PrivacyPromise , trust micro-section addressing the #1 concern
 * older patients and caregivers raise: "what happens to my data?".
 * Light section, teal accent.
 */
export const PrivacyPromise = () => {
  const promises = [
    {
      icon: EyeOff,
      title: "Your name never leaves",
      body:
        "Everything you share in an interview is anonymized before it reaches the researcher.",
    },
    {
      icon: Lock,
      title: "Secure Zoom, always",
      body:
        "Interviews run over password-protected Zoom calls. Recordings are encrypted at rest.",
    },
    {
      icon: ShieldCheck,
      title: "We never sell your data",
      body:
        "MediTalk will never share, sell or rent your personal information. That is a promise.",
    },
  ];

  return (
    <section className="bg-[var(--light-card)]" data-testid="privacy-promise">
      <div className="container-main py-16 md:py-20">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16 items-start">
          <div className="lg:col-span-5">
            <span className="badge badge-light mb-4">Privacy, by default</span>
            <h2 className="font-['Outfit'] font-bold text-[var(--navy)] tracking-tight text-3xl md:text-4xl mb-4 leading-tight">
              Your story is yours.
              <br />
              We just listen.
            </h2>
            <p className="text-[var(--text-muted)] text-lg leading-relaxed">
              Sharing something personal takes trust. Here is exactly how we
              protect what you tell us, before you ever press join on a call.
            </p>
          </div>

          <ul className="lg:col-span-7 grid grid-cols-1 sm:grid-cols-3 gap-5">
            {promises.map(({ icon: Icon, title, body }) => (
              <li
                key={title}
                className="bg-white border border-[var(--light-border)] rounded-2xl p-6 hover:border-[var(--teal)] transition-colors"
              >
                <span className="w-12 h-12 rounded-xl bg-[var(--teal-soft)] text-[var(--teal-dark)] flex items-center justify-center mb-4">
                  <Icon size={22} strokeWidth={1.8} />
                </span>
                <h3 className="font-['Outfit'] font-semibold text-[var(--navy)] text-base mb-2 leading-snug">
                  {title}
                </h3>
                <p className="text-[var(--text-muted)] text-sm leading-relaxed">
                  {body}
                </p>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </section>
  );
};
